module.exports = __webpack_public_path__ + "static/media/view-demo-1.2bbf680c.png";